"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function MssqlGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#prefix__mssql-green-multitone-filled__clip0_13467_72)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M7.399 9.59v-.001-.005a.144.144 0 01.017-.032.632.632 0 01.148-.154c.17-.134.449-.277.84-.408.776-.258 1.882-.427 3.128-.427 1.246 0 2.352.169 3.129.427.39.13.669.274.839.408a.632.632 0 01.149.154.151.151 0 01.017.037v.001l-.002.005a.151.151 0 01-.015.032.632.632 0 01-.15.154c-.169.134-.447.277-.838.408-.777.258-1.883.428-3.129.428s-2.352-.17-3.128-.428c-.391-.13-.67-.274-.84-.408a.632.632 0 01-.148-.154.144.144 0 01-.017-.037zM.335 1.226c0-.012.006-.106.212-.269.2-.157.523-.322.968-.47C2.399.19 3.655 0 5.065 0c1.41 0 2.666.191 3.55.486.446.149.768.314.968.471.206.163.212.257.212.269 0 .012-.006.106-.212.269-.2.157-.522.322-.967.47-.885.296-2.14.487-3.55.487-1.412 0-2.667-.191-3.551-.486-.445-.149-.768-.314-.968-.471-.206-.163-.212-.257-.212-.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M9.657 1.431H.473c.021.02.046.041.074.064.2.157.522.322.967.47.885.296 2.14.487 3.55.487 1.412 0 2.667-.191 3.551-.486.445-.149.768-.314.968-.471a1.22 1.22 0 00.074-.064zm.664.818a2.266 2.266 0 01-.087.072c-.332.262-.78.474-1.286.643-1.018.34-2.39.54-3.883.54-1.492 0-2.865-.2-3.883-.54-.507-.169-.954-.381-1.286-.643a2.274 2.274 0 01-.088-.073v4.09c0 .23.136.457.4.67.264.213.651.406 1.14.569a9.645 9.645 0 001.705.38c.638.087 1.321.133 2.011.133.69 0 1.374-.046 2.012-.134a9.645 9.645 0 001.705-.38c.488-.162.876-.355 1.14-.568.264-.213.4-.44.4-.67V2.249z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M8.404 10.189c.514.17 1.172.303 1.92.373V8.617c-.748.07-1.406.202-1.92.373-.391.13-.67.274-.84.408a.632.632 0 00-.148.154.145.145 0 00-.017.037v.006a.145.145 0 00.017.032.632.632 0 00.148.154c.17.134.449.277.84.408zM8.07 7.992c.625-.208 1.399-.358 2.252-.431V6.22s-1.36 1.635-5.256 1.635C.917 7.856-.19 6.222-.19 6.222v5.222c0 .342.136.68.4.997.264.316.652.602 1.14.844a7.077 7.077 0 001.705.565 10.394 10.394 0 003.31.117V9.845h.012c-.02-.081-.03-.166-.03-.255 0-.445.27-.785.566-1.018.302-.238.706-.43 1.158-.58zm-.616 2.948v2.823c.49-.123.938-.285 1.329-.478.488-.242.875-.528 1.139-.844.22-.263.35-.541.389-.824-.85-.073-1.619-.223-2.241-.43a5.087 5.087 0 01-.616-.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M11.532 9.773h3.978l-.01.008c-.17.134-.448.277-.84.408-.776.258-1.882.428-3.128.428-1.246 0-2.352-.17-3.128-.428-.391-.13-.67-.274-.84-.408l-.01-.008h3.978zm4.62.834l.04-.032v3.547c0 .204-.121.405-.355.594-.235.188-.578.36-1.01.504a8.556 8.556 0 01-1.512.337 13.17 13.17 0 01-1.783.118c-.612 0-1.218-.04-1.784-.118a8.555 8.555 0 01-1.511-.337 3.958 3.958 0 01-.782-.346V10.94c.19.092.397.174.616.247.91.303 2.133.482 3.461.482 1.328 0 2.551-.179 3.461-.482.453-.15.857-.342 1.158-.58z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__mssql-green-multitone-filled__clip0_13467_72"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

MssqlGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
MssqlGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = MssqlGreenMultitoneFilled;
exports["default"] = _default;